import ApiHourlyRateHistory from "./api/api";
import HourlyCost from "./hourly-cost";


export async function loadHourlyCost():Promise<HourlyCost> {

    if (!gd._hourlyCost) {
        const records = await ApiHourlyRateHistory.selectAll().promise()
        gd._hourlyCost = new HourlyCost(records)
    }

    return gd._hourlyCost

}
